export default __webpack_public_path__ + "static/media/coins.1eaa5dc0.svg";